import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DateIntervalUtils } from '@iot-platform/iot-platform-utils';
import { DateFormatPipe } from '@iot-platform/pipes';
import moment from 'moment';

@Component({
  selector: 'iot-platform-ui-date-time',
  standalone: true,
  imports: [NgClass, DateFormatPipe],
  providers: [DateFormatPipe],
  template: `
    <span [ngClass]="{ recentDay: isRecentDay(), recentHour: isRecentHour(), futureDay: isFutureDay(), nextDay: isNextDay() }" class="date-time">
      {{ dateValue() | dateFormat: dateFormat() : dateTimezone() : [removeTimezone()] }}
    </span>
  `,
  styleUrls: ['./date-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateTimeComponent {
  readonly dateValue = input<string>();
  readonly dateFormat = input<string>('');
  readonly dateTimezone = input<string>(null);
  readonly removeTimezone = input<boolean>(false);

  readonly isRecentDay = computed(() => DateIntervalUtils.isDateInThePastDay(moment(), this.dateValue()));
  readonly isRecentHour = computed(() => DateIntervalUtils.isDateInThePastHour(moment(), this.dateValue()));
  readonly isNextDay = computed(() => DateIntervalUtils.isDateInTheNextDay(moment(), this.dateValue()));
  readonly isFutureDay = computed(() => DateIntervalUtils.isDateInTheFutureDays(moment(), this.dateValue()));
}
